import { StringSetConverter, UserRoles } from '@amzn/awscat-pattern-library-service-model';
import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('UserProfile')
class UserProfile {
  @JsonProperty('userId', String)
  // @ts-expect-error TS2322 - strict migration
  userId: string = undefined;
  @JsonProperty('name', String, true)
  // @ts-expect-error TS2322 - strict migration
  name: string = undefined;
  @JsonProperty('email', String, true)
  // @ts-expect-error TS2322 - strict migration
  email: string = undefined;
  @JsonProperty('type', String, true)
  // @ts-expect-error TS2322 - strict migration
  type: string = undefined;
  @JsonProperty('roles', StringSetConverter, true)
  roles: Set<UserRoles> = new Set();
}

export default UserProfile;
